import { http } from '@/shared/api/httpClient';
import type { LoginResponse } from '../model/types';

/**
 * Wywolania endpointow `/api/auth/**`.
 *
 * Sa to endpointy publiczne (patrz `gateway/config/SecurityConfig`), dlatego
 * jawnie pomijamy naglowek `Authorization` — inaczej wygasly token
 * niepotrzebnie uruchamialby probe odswiezenia.
 */

export interface LoginPayload {
  email: string;
  password: string;
}

/** Loguje uzytkownika i zwraca komplet tokenow. */
export function login(payload: LoginPayload): Promise<LoginResponse> {
  return http.post<LoginResponse>(
    '/auth/login',
    { ...payload, deviceType: 'WEB' },
    { skipAuth: true, skipRefresh: true },
  );
}

/** Wymienia refresh token na nowy token dostepu. */
export function refresh(refreshToken: string): Promise<LoginResponse> {
  return http.post<LoginResponse>(
    '/auth/refresh',
    { refreshToken },
    { skipAuth: true, skipRefresh: true },
  );
}

/** Uniewaznia refresh token i deaktywuje sesje po stronie serwera. */
export function logout(refreshToken: string): Promise<void> {
  return http.post<void>('/auth/logout', { refreshToken }, { skipRefresh: true });
}
